<template>
  <div class="bg-gray">
    <navigation-bar :mode="'Admin'"></navigation-bar>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12" style="padding-top:20px;">
            <div class="row">
              <div class="col-xs-12 col-sm-12 text-left">
                <div>
                    <h3 style="float:left;">Admin Site Announcements</h3>
                    <button @click="create" style="float:left;margin-left:10px;margin-top:5px;" type="button" class="btn btn-primary btn-blue" aria-label="Left Align">
                      <i class="fa fa-plus fa-sm"></i>
                    </button>
                  </div>
              </div>
            </div>

            <div class="row" style="margin-top:20px;" v-if="store.state.selectedAnnouncement">
              <div class="col-xs-12 col-sm-12">
                <hr>
                <h5>{{store.state.selectedAnnouncement.id ? 'Edit Announcement' : 'Create Announcement'}}</h5>
                <div class="form-group">
                  <label>Title</label>
                  <input class="form-control" v-model="store.state.selectedAnnouncement.title" placeholder="Title" />
                </div>

                <div class="form-group">
                  <label>Description</label>
                  <textarea class="form-control" v-model="store.state.selectedAnnouncement.description" placeholder="Description" ></textarea>
                </div>


                <button class="btn btn-primary btn-blue" @click="save">Save</button>
                <button class="btn btn-primary btn-orange" @click="cancel">Cancel</button>
                <hr>
              </div>
            </div>


            <div class="row" style="margin-top:20px;">
              <div class="col-xs-12 col-sm-12">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>
                        Title
                      </th>
                      <th>
                        Description
                      </th>
                      <th>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="announcement in store.state.announcements" :key="announcement.id">
                      <td>
                        {{announcement.title}}
                      </td>
                      <td>
                        {{announcement.description}}
                      </td>
                      <td>
                        <button class="btn btn-primary btn-blue" @click="edit(announcement)">
                          <i class="fa fa-pencil fa-sm"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-sm-12">
              </div>
            </div>

        </div>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from '../nav/NavigationBar.vue'
import DashboardFooter from '../nav/Footer'
import Utils from '@/Utils/Utils'
import Navigator from '@/router/navigator'
import AdminAnnouncementsStore from './AdminAnnouncementsStore'
import AdminPermissionsUtils from './AdminPermissionsUtils'

export default {
  name: 'AdminSiteAnnouncements',
  components: {
    NavigationBar,
    DashboardFooter
  },
  data () {
    return {
      nav: Navigator,
      store: AdminAnnouncementsStore,
      adminUtils: AdminPermissionsUtils
    }
  },
  mounted () {
    this.adminUtils.authorize((userId) => {
      this.store.state.currentUserId = userId;
      this.load()
    },(err) => {
      this.nav.goAdminLogin(this)
    })
  },
  methods: {
    load() {
      this.store.state.selectedAnnouncement = null
      this.store.getAnnouncements(data => {
        this.$forceUpdate();
      },err => {

      });
    },
    save() {
      this.store.save(this.store.state.selectedAnnouncement,() => {
          this.$toasted.show(`Announcement saved!`, { type: 'success', duration: 2500 })
          this.load()
        }, () => {
          this.$toasted.show(err, { type: 'error', duration: 2500 })
        });
    },
    cancel() {
      this.store.state.selectedAnnouncement = null
    },
    create() {
      this.store.state.selectedAnnouncement = {title:'',desc:''}
    },
    edit(announcement) {
      this.store.state.selectedAnnouncement = announcement
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminAnnouncements.vue